import { Component, Input } from '@angular/core';

import { BackLinkInterface } from '~/checkout/interfaces/back-link.interface';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-organizer-shared-header',
  templateUrl: './header.component.html',
})
export class OrganizerSharedHeaderComponent {
  @Input() public backLink: BackLinkInterface;
  @Input() public backLinkAriaLabel: string;
  @Input() public title: string;

  public readonly iconType = VtmnPlayIconTypeEnum;
}
